import { Component, OnInit } from '@angular/core';
import { Dealer, Distributor, Course } from '../../model/distributor.model';
import { DistributorService } from '../../services/distributor.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-dealer-view',
  templateUrl: './dealer-view.component.html',
  styleUrls: ['./dealer-view.component.scss']
})
export class DealerViewComponent implements OnInit {

  dealer: Dealer = new Dealer({});
  distributor: Distributor = new Distributor({});
  training: Array<Course> = [];

  constructor(private distributorSvc: DistributorService) { }

  ngOnInit() {
    /* TODO: get dealerId from route */
    forkJoin(
      this.distributorSvc.fetchDealer(),
      this.distributorSvc.fetchTrainingByDealer()
    ).subscribe(results => {
      this.dealer = results[0];
      this.distributor = results[0].distributor;
      // this.employees = results[0].employees;
      this.training = results[1];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/distributor/containers/dealer-view/dealer-view.component.ts